import { gql } from 'graphql-tag'
import queryPageFields from '#layers/core/data-layer/pages/page/query-page-fields.js'

export default gql`
  query($slug: String!, $locale: String!, $preview: Boolean! = false) {
    page: pageLicensesCollection(limit: 1, where: { slug: $slug }, locale: $locale, preview: $preview) {
      items {
        ${queryPageFields}
        itemsCollection {
          items {
            sys {
              id
            }
            title
            icon
            navigationTitle
          }
        }
      }
    }
  }
`
